import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getPatentsApplicationId(applicationId: string) {
  return await prisma.applicantPatent.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
